  export class UpdateImageAppModel {
    title: string
    linkUrl: string
    file: File
    userEmail: string
    imageAppSurrKey: number
    isUploadFile: boolean
  }